<template>

  <div :id="element.id" :style="getStyle">

    <div :style="`background: ${element?.option.backgroundColor};width: 100%;height: 100%`">

      <div style="padding: 20px;font-size: 16px;color: #E5E3FD">{{element?.option.title}}</div>
      <div style="padding: 10px 20px;font-size: 26px;color: white">{{element?.option.text}}<span style="font-size: 12px;margin-left: 5px">{{element?.option.suffix}}</span></div>
<!--      <div style="padding: 10px 20px;font-size: 12px;color: rgba(232,228,228,0.75)">同月比 <span style="color: #edecf3">{{Math.floor(Math.random() * 141) - 30}}%</span></div>-->

    </div>

  </div>

</template>

<script>
//防止vue代理chart实例被代理
import {markRaw} from 'vue';
import chartFactory from "@/components/design-report/chartFactory";

export default {
  props: {
    element: {
      type: Object,
      default: () => {
        return {}
      }
    },
    ratio: {
      type:Object,
      default:()=>{
        return {
          width: 1,
          height: 1
        }
      }
    },
    mode: {
      type: String,
      default: 'edit'
    },
    diving: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    "element.w": {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.resize();
        });
      },
      immediate: false
    },
    "element.h": {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.resize();
        });
      },
      immediate: false
    },
    "element.option": {
      handler(newValue, oldValue) {
        this.preview()
      },
      deep: true,
      immediate: false
    }
  },
  computed: {
    getStyle() {

      if (this.mode === 'edit') {
        return {
          width: `${this.element.w * this.ratio.width}px`,
          height: `${this.element.h * this.ratio.height}px`
        }
      } else {
        return {
          position: this.diving ? 'none' : 'absolute',
          'box-sizing': 'border-box',
          width: `${this.element.w * this.ratio.width}px`,
          height: `${this.element.h * this.ratio.height}px`,
          transform: this.diving ? 'none' : `translate(${this.element.x * this.ratio.width}px, ${this.element.y * this.ratio.height}px)`,
          'z-index': this.element.index,
        }
      }


    }
  },
  data() {
    return {
      chart: null,
      isPreviewing: false
    }
  },
  mounted() {
    this.preview()

  },
  methods: {
    preview() {


    },
    resize() {
    }
  }


}

</script>

<style scoped lang="scss">

</style>